/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { FeedType } from "@octopusdeploy/octopus-server-client";
import type * as H from "history";
import * as React from "react";
import type { RouteComponentProps } from "react-router";
import { repository } from "~/clientInstance";
import AreaTitle from "~/components/AreaTitle";
import type { DataBaseComponentState } from "~/components/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent";
import PaperLayout from "~/components/PaperLayout";
import InternalRedirect from "../../../../components/Navigation/InternalRedirect/InternalRedirect";
import routeLinks from "../../../../routeLinks";
interface OverviewFilterRedirectState extends DataBaseComponentState {
    redirectTo?: H.LocationDescriptor;
}
interface FeedParams {
    feedId: string;
}
export class RedirectFeedBasedOnType extends DataBaseComponent<RouteComponentProps<FeedParams>, OverviewFilterRedirectState> {
    constructor(props: RouteComponentProps<FeedParams>) {
        super(props);
        this.state = {
            redirectTo: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const id = this.props.match.params.feedId;
            const feed = await repository.Feeds.get(id);
            const root = routeLinks.forSpace(feed.SpaceId);
            const redirectTo = feed.FeedType === FeedType.BuiltIn ? root.library.builtInRepository.root : root.library.feed(id).root;
            this.setState({ redirectTo });
        });
    }
    render() {
        const to = this.state.redirectTo;
        if (!to) {
            return (<main id="maincontent">
                    <AreaTitle link={routeLinks.configuration.teams.root()} title="Library"/>
                    <PaperLayout busy={this.state.busy} fullWidth={true} errors={this.errors}/>
                </main>);
        }
        return <InternalRedirect push={false} to={to}/>;
    }
    static displayName = "RedirectFeedBasedOnType";
}
